import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Eye, EyeOff, KeyRound } from "lucide-react";
import { toast } from "sonner";

const PwField = ({ label, value, onChange, testid }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="space-y-1">
      <Label>{label}</Label>
      <div className="relative">
        <Input data-testid={testid} type={show ? "text" : "password"} value={value} onChange={onChange} className="h-11 pr-11" autoComplete="off" />
        <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((v) => !v)}
          title={show ? "Nascondi password" : "Mostra password"} aria-label={show ? "Nascondi password" : "Mostra password"}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
          {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
        </button>
      </div>
    </div>
  );
};

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNw(""); setCf(""); setErr(""); };

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (nw.length < 8) return setErr("La nuova password deve avere almeno 8 caratteri.");
    if (nw !== cf) return setErr("La conferma password non corrisponde.");
    if (nw === cur) return setErr("La nuova password deve essere diversa da quella attuale.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password aggiornata. Per sicurezza devi accedere di nuovo.");
      setTimeout(() => { window.location.href = "/login"; }, 900);
    } catch (e2) {
      setErr(apiErr(e2, "Impossibile aggiornare la password."));
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) reset(); }}>
      <DialogTrigger asChild>
        <Button data-testid="change-password-btn" variant="outline" className="rounded-full">
          <KeyRound className="h-4 w-4 mr-1" />Cambia password
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <PwField label="Password attuale" value={cur} onChange={(e) => setCur(e.target.value)} testid="cp-current" />
          <PwField label="Nuova password (min. 8 caratteri)" value={nw} onChange={(e) => setNw(e.target.value)} testid="cp-new" />
          <PwField label="Conferma nuova password" value={cf} onChange={(e) => setCf(e.target.value)} testid="cp-confirm" />
          {err && <p data-testid="cp-error" className="text-sm text-destructive font-medium">{err}</p>}
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => setOpen(false)} data-testid="cp-cancel">Annulla</Button>
            <Button type="submit" disabled={busy} data-testid="cp-submit" className="rounded-full">
              {busy ? "Aggiornamento…" : "Aggiorna password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
